"use client";

import { RefreshCw } from "lucide-react";

interface InstagramLoadMoreProps {
  onLoadMore?: () => void;
  loading?: boolean;
}

export default function InstagramLoadMore({
  onLoadMore,
  loading = false,
}: InstagramLoadMoreProps) {
  return (
    <div className="text-center mt-12">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={loading}
        className="inline-flex items-center gap-2 bg-white/40 text-black px-8 py-3 rounded-full font-medium hover:bg-white/60 transition-all duration-300 hover:scale-105 border border-white/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <RefreshCw className={`w-5 h-5 ${loading ? "animate-spin" : ""}`} />
        {loading ? "Loading..." : "Load More Posts"}
      </button>
    </div>
  );
}
